export const CONTENT_LIBRARY_HEADER_DESCRIPTION =
  'Browse our extensive library to find & add content sources to your newsletter.'
